import axios from 'axios';
import { allCollectionCategoryList } from '../site-settings/category';
import * as dummy from '../test-api/dummyData';
import poodleData from '../assets/dumans_data/poodle.json';
import bulldogData from '../assets/dumans_data/bulldog.json';
import collinData from '../assets/dumans_data/coliin.json';
import dobermanData from '../assets/dumans_data/doberman.json';
import kmData from '../assets/dumans_data/km.json';
import hyattData from '../assets/membership_json/hyatt.json';
import tsData from '../assets/membership_json/ts.json';
import dummyShilla from '../test-api/dummy-shilla/json/dummy.json';
import mammothData from '../assets/membership_json/mammoth.json';
import mysteryData from '../assets/membership_json/mystery.json';
import lotteData from '../assets/membership_json/lotte.json';
import vluvData from '../assets/membership_json/vluv.json';
import dummy_product_platinum from '../test-api/dummy-shilla/json/dummy_product_platinum.json';
import dummy_product_gold from '../test-api/dummy-shilla/json/dummy_product_gold.json';
import dummy_product_silver from '../test-api/dummy-shilla/json/dummy_product_silver.json';
import { detect } from 'detect-browser';
import { AES, enc } from 'crypto-js';
/**
 * 선택된 원화 리스트를 더미데이터에서 불러옴
 * @function _getCurrencyList
 * @returns {array} dummy.tempCurrencyList
 */
export function _getCurrencyList() {
	return dummy.tempCurrencyList;
}
/**
 * 선택된 정렬 버튼 텍스트 리스트를 더미데이터에서 불러옴
 * @function _getNftMarketSortList
 * @returns {array} dummy.tempNftMarketSortList
 */
export function _getNftMarketSortList() {
	return dummy.tempNftMarketSortList;
}
/**
 * 선택된 카테고리 텍스트 리스트를 더미데이터에서 불러옴
 * @function _getNftMarketCategoryList
 * @returns {array} dummy.tempNftMarketCategoryList
 */
export function _getNftMarketCategoryList() {
	return dummy.tempNftMarketCategoryList;
}
/**
 * 선택된 카테고리 헤더의 텍스트 리스트를 더미데이터에서 불러옴
 * @function _getNftMarketCategoryHeaderList
 * @returns {array} dummy.nftMarketCategoryHeaderData
 */
export function _getNftMarketCategoryHeaderList() {
	return dummy.nftMarketCategoryHeaderData;
}
/**
 * 선택된 갤러리의 정렬 버튼 텍스트 리스트를 더미데이터에서 불러옴
 * @function _getGallerySortList
 * @returns {array} dummy.tempGallerySortList_en || dummy.tempGallerySortList_ko
 */
export function _getGallerySortList(language) {
	if (language === 'ko') return dummy.tempGallerySortList_ko;
	else return dummy.tempGallerySortList_en;
}
/**
 * 선택된 갤러리의 카테고리 텍스트 리스트를 더미데이터에서 불러옴
 * @function _getGalleryCategoryList
 * @returns {array} dummy.tempGallerySortList_en || dummy.tempGallerySortList_ko
 */
export function _getGalleryCategoryList(language) {
	if (language === 'ko') return dummy.tempGalleryCategoryList_ko;
	else return dummy.tempGalleryCategoryList_en;
}
/**
 * 선택된 갤러리의 카테고리 헤더의 텍스트 리스트를 더미데이터에서 불러옴
 * @function _getGalleryCategoryHeaderList
 * @returns {array} dummy.tempGalleryCategoryHeaderData_en || dummy.tempGalleryCategoryHeaderData_ko
 */
export function _getGalleryCategoryHeaderList(language) {
	if (language === 'ko') return dummy.tempGalleryCategoryHeaderData_ko;
	else return dummy.tempGalleryCategoryHeaderData_en;
}
/**
 * 갤러리 전체의 데이터를 설정
 * @param {string} category
 * @param {string} subCategory
 * @param {number} page
 * @param {number} pagePerItem
 * @function _getGalleryData
 * @returns {array} listData
 */

export function _getGalleryData(category, subCategory, page, pagePerItem = 6) {
	if (page <= 0) return [];

	const beginIndex = pagePerItem * (page - 1);
	const endIndex = beginIndex + pagePerItem;

	let list;

	list = poodleData;

	if (category === 'DUMAN') {
		if (subCategory === 'Tori' || subCategory === '푸들') {
			list = poodleData;
		} else if (subCategory === 'Collin' || subCategory === '보더콜리') {
			list = collinData;
		} else if (subCategory === 'Dove' || subCategory === '도베르만') {
			list = dobermanData;
		} else if (subCategory === 'KM' || subCategory === '진도') {
			list = kmData;
		} else if (subCategory === 'Andre' || subCategory === '불독') {
			list = bulldogData;
		}
	} else if (category === 'Mystery Box') {
		list = mysteryData;
	} else if (category === 'Konnect Product Card') {
		if (subCategory === 'Platinum' || subCategory === '플래티넘') {
			list = dummy_product_platinum;
		} else if (subCategory === 'Gold' || subCategory === '골드') {
			list = dummy_product_gold;
		} else if (subCategory === 'Silver' || subCategory === '실버') {
			list = dummy_product_silver;
		} else {
			list = [];
		}
	} else if (category === 'Partners Utility Card') {
		list = dummyShilla;
	} else if (category === 'Konnect Membership') {
		switch (subCategory) {
			case 'PARK HYATT MEMBERSHIP CARD':
				list = hyattData;
				break;
			case 'LOTTE HOTEL MEMBERSHIP CARD':
				list = lotteData;
				break;
			case 'TS TRILLION MEMBERSHIP CARD':
				list = tsData;
				break;
			case 'MAMMOTH MEMBERSHIP CARD':
				list = mammothData;
				break;
			case 'VLUV MEMBERSHIP CARD':
				list = vluvData;
				break;
		}
	} else {
		list = [];
	}

	const filteredlist = list;
	const totalItems = filteredlist.length;
	const pagingList = filteredlist.slice(beginIndex, endIndex);
	const isLastPage = pagingList.length < pagePerItem ? true : false;

	return { data: pagingList, isLastPage, totalItems };
}
/**
 * 전체 데이터 대분류 카테고리를 가져옴
 * @param {boolean} isMobileMode
 * @function _getAllCollectionCategoryList
 * @returns {array} list
 */
export function _getAllCollectionCategoryList(isMobileMode = false) {
	const list = allCollectionCategoryList(isMobileMode);
	return list;
}

/**
 * 전체 데이터 대분류 카테고리를 가져옴
 * @param {array} originalData
 * @param {string} categoryList
 * @param {number} mainCategoryIndex
 * @function _categorizeAtKonnectWallet
 * @returns {object} resultObj
 */
export function _categorizeAtKonnectWallet(
	originalData = [],
	categoryList,
	mainCategoryIndex
) {
	let list = [];
	let resultObj = {};

	// if (categoryList.length > 3) {
	if (categoryList.length > 4) {
		switch (mainCategoryIndex) {
			case 0: //NFT Package
				list = originalData.filter(x => x.type === 'box');
				break;
			case 3: //PFP NFT
				list = originalData.filter(
					x =>
						x.type === 'product' &&
						x.data.product_index?.category === 'PFP'
				);
				break;
			case 4: //Membership Card
				list = originalData.filter(
					x =>
						x.type === 'product' &&
						x.data.product_index?.category === 'Membership'
				);
				break;
			case 5: //Partners Utility Card
				list = originalData.filter(
					x =>
						x.type === 'product' &&
						x.data.product_index?.category === 'Utility'
				);
				break;
			default:
				list = [];
				break;
		}

		categoryList[mainCategoryIndex].subCategories.forEach(
			(subCategory, subCategoryIndex) => {
				if (subCategoryIndex === 0) {
					resultObj[0] = list;
				} else {
					resultObj[subCategoryIndex] = list.filter(x => {
						switch (mainCategoryIndex) {
							case 3: //PFP NFT
								return (
									x.data.product_index.brand ===
									subCategory.name.en
								);
							default:
								return true;
						}
					});
				}
			}
		);
	} else {
		switch (mainCategoryIndex) {
			case 0: //ALL
				list = originalData;
				break;
			case 1: //Membership Card
				list = originalData.filter(
					x =>
						x.type === 'product' &&
						(x.data.product_index?.category === 'Membership' ||
							x.data.product_index?.category === 'Utility')
				);
				break;
			case 2: //NFT
				list = originalData.filter(
					x =>
						x.type === 'product' &&
						x.data.product_index?.category === 'PFP'
				);
				break;
			case 3: //Box
				list = originalData.filter(x => x.type === 'box');
				break;
			default:
				list = [];
				break;
		}
		resultObj[0] = list;
	}

	return resultObj;
}
/**
 * OnChain 상에있는 데이터 리스트를 가져옴
 * @param {number} tokenIds
 * @async
 * @function _getOnChainCollectionItems
 * @returns {array} resultArray
 */
export async function _getOnChainCollectionItems(tokenIds, address) {
	let resultArr = [];

	const body = {
		data: [...tokenIds],
	};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/onchain_product_info`,
			data: body,
		});

		if (response.data.RETCODE === 'GET_ONCHAIN_PRODUCT_INFO_FAIL_NO_DATA') {
			// return resultObj;
			return [];
		} else if (
			response.data.RETCODE !== 'GET_ONCHAIN_PRODUCT_INFO_SUCCESS'
		) {
			throw new Error(response.data.RETCODE);
		}

		resultArr = response.data.results.map(item => {
			const resultObj = {
				type: 'product',
				isOnChain: true,
				data: item,
			};

			return resultObj;
		});

		return resultArr;
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * OffChain - 보유중인 박스 가져옴
 * @param {string} address
 * @async
 * @function _getOffChainCollectionBoxes
 * @returns {array} resultArr
 */
export async function _getOffChainCollectionBoxes(address) {
	let resultArr = [];

	const body = {
		walletAddress: address,
	};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/box_list`,
			data: body,
		});

		if (response.data.RETCODE !== 'GET_BOX_LIST_SUCCESS') {
			throw new Error(response.data.RETCODE);
		}

		resultArr = response.data.results.map(item => {
			const resultObj = {
				type: 'box',
				isOnChain: false,
				data: item,
			};

			return resultObj;
		});

		return resultArr;
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * OffChain - 보유중인 프로덕트 목록을 가져옴
 * @param {string} address
 * @async
 * @function _getOffChainCollectionBoxes
 * @returns {array} resultArr
 */
export async function _getOffChainCollectionProducts(address) {
	let resultArr = [];

	const body = {
		walletAddress: address,
	};
	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/product_list`,
			data: body,
		});

		if (response.data.RETCODE !== 'GET_PRODUCT_LIST_SUCCESS') {
			throw new Error(response.data.RETCODE);
		}

		resultArr = response.data.results.map(item => {
			const resultObj = {
				type: 'product',
				isOnChain: false,
				data: item,
			};

			return resultObj;
		});
		return resultArr;
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * OffChain - 보유중인 박스 데이터를 이메일정보를 통해 목록을 가져옴
 * @param {string} email
 * @async
 * @function _getOffChainCollectionBoxesAsEmail
 * @returns {array} resultArr
 */
export async function _getOffChainCollectionBoxesAsEmail(email) {
	let resultArr = [];

	const body = {
		email: email,
	};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/`,
			data: body,
		});

		if (response.data.RETCODE !== 'GET_BOX_LIST_SUCCESS') {
			throw new Error(response.data.RETCODE);
		}

		resultArr = response.data.results.map(item => {
			const resultObj = {
				type: 'box',
				data: item,
			};

			return resultObj;
		});

		return resultArr;
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * OffChain - 보유중인 프로덕트 데이터를 이메일정보를 통해 목록을 가져옴
 * @param {string} email
 * @async
 * @function _getOffChainCollectionProductsAsEmail
 * @returns {array} resultArr
 */
export async function _getOffChainCollectionProductsAsEmail(email) {
	let resultArr = [];

	const body = {
		emailAddress: email,
	};
	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/product_list_email`,
			data: body,
		});

		if (response.data.RETCODE !== 'GET_PRODUCT_LIST_EMAIL_SUCCESS') {
			throw new Error(response.data.RETCODE);
		}

		resultArr = response.data.results.map(item => {
			const resultObj = {
				type: 'product',
				data: item,
			};

			return resultObj;
		});
		return resultArr;
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * 선택된 토큰을 LazyMint 요청 (Redeem)
 * @param {string} address
 * @param {object} productData
 * @async
 * @function _exportTokenToLazyMint
 * @returns {object} data
 */
export async function _exportTokenToLazyMint(address, productData) {
	const body = {
		walletAddress: address,
		type: productData.user_box_index.type, // 22-09-22 추가 author: ydw
		account: address,
		nftId: productData.nft_no,
		IPFSMetadataIPFSURL: productData.ipfs_metadata_ipfs_url,
		userProductIndex: productData.index,
	};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/export-token-to-lazy-mint`,
			data: body,
		});

		if (response.data.RETCODE === 'LAZYMINTING_SUCCESS') {
			return { data: response.data.results };
		} else {
			throw new Error(response.data.RETCODE);
		}
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * LazyMint 요청이 완료된 토큰의 상태를 변경 (Redeem)
 * @param {string} address
 * @param {object} productData
 * @async
 * @function _reportCompleteExportTokenToLazyMint
 * @returns {object} response.data.results
 */
export async function _reportCompleteExportTokenToLazyMint(
	address,
	productData
) {
	const body = {
		account: address,
		nftId: productData.nft_no,
	};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/export-token-to-lazy-mint-completed`,
			data: body,
		});

		_inputActionLog(
			address,
			'_reportCompleteExportTokenToLazyMint',
			JSON.stringify(response)
		);

		if (response.data.RETCODE === 'REDEEM_SUCCESS') {
			return response.data.results;
		} else {
			throw new Error(response.data.RETCODE);
		}
	} catch (error) {
		_inputActionLog(
			address,
			'_reportCompleteExportTokenToLazyMint error',
			JSON.stringify(error)
		);
		throw new Error(error);
	}
}
/**
 * 선택된 package를 unboxing함
 * @param {string} address
 * @param {boxIndex} number
 * @async
 * @function _unbox
 * @returns {object} response.data
 */
export async function _unbox(address, boxIndex) {
	const body = {
		walletAddress: address,
		boxIndex,
	};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/unboxing`,
			data: body,
		});

		_inputActionLog(address, '_unbox', JSON.stringify(response));

		if (response.data.RETCODE === 'UNBOXING_COMPLETED') {
			return response.data;
		} else {
			throw new Error(response.data.RETCODE);
		}
	} catch (error) {
		_inputActionLog(address, '_unbox error', JSON.stringify(error));
		throw new Error(error);
	}
}

/**
 * Staking을 진행한 유저의 등급을 표시
 * @param {string} address
 * @async
 * @function _getMembershipRank
 * @returns {string} membershipRank
 */
export async function _getMembershipRank(address) {
	const body = {
		walletAddress: address,
	};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/check_userstaking`,
			data: body,
		});

		if (response.data.RETCODE === 'USER_STAKING_LIST_CHECK_COMPLETED') {
			if (
				response.data.results.processing.length > 0 &&
				response.data.results.processing[0].membership_level_index.type
			) {
				return response.data.results.processing[0]
					.membership_level_index.type;
			} else {
				return 'N/A';
			}
		} else {
			throw new Error(response.data.RETCODE);
		}
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * minting 이벤트에서 box 구매 실행 (1개 기준)
 * @param {string} address
 * @param {number} nftIndex
 * @param {string} txHash
 * @param {number} price
 * @param {string} tokenType
 * @async
 * @function _requestPurchaseBox
 * @returns {object} reponse.data
 */
export async function _requestPurchaseBox(
	address,
	nftIndex,
	txHash,
	price,
	tokenType
) {
	const body = {
		walletAddress: address.toLowerCase(),
		kctNftIndex: nftIndex,
		txHash: txHash.toLowerCase(),
		price,
		tokenType: tokenType.toLowerCase(),
	};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/box_buy`,
			data: body,
		});
		_inputActionLog(
			address,
			'_requestPurchaseBox',
			JSON.stringify(response)
		);

		if (response.data.RETCODE === 'BOX_BUY_LIST_ADD_COMPLETE') {
			return response.data;
		} else {
			throw new Error(response.data.RETCODE);
		}
	} catch (error) {
		_inputActionLog(
			address,
			'_requestPurchaseBox error',
			JSON.stringify(error)
		);
		throw new Error(error);
	}
}

/**
 * Nft 정보를 불러옴
 * @param {object} filterQueries
 * @async
 * @function _getKctNftInfo
 * @returns {object} kctNftInfo
 */
export async function _getKctNftInfo(filterQueries = {}) {
	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/kct_nft_list`,
		});

		if (response.data.RETCODE === 'GET_KCT_NFT_LIST_SUCCESS') {
			let kctNftInfo = [...response.data.results];

			for (const filterKey in filterQueries) {
				kctNftInfo = kctNftInfo.filter(
					x => x[filterKey] === filterQueries[filterKey]
				);
			}

			return { data: kctNftInfo };
		} else {
			throw new Error(response.data.RETCODE);
		}
	} catch (error) {
		throw new Error(error);
	}
}

/**
 * huobi global 에서 가져온 전일 종가 기준 usdt 환율을 가져옴
 * @async
 * @function _getExchangeData
 * @returns {object} exchangeData
 */
export async function _getExchangeData() {
	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/huobi_global_kct_usdt_price`,
		});

		if (
			response.data.RETCODE ===
			'HUOBI_GLOBAL_KCT_ETH_USDT_PRICE_CHECK_COMPLETE'
		) {
			let exchangeData = {
				usdt: 1,
				kct: response.data.results.kctusdt.price,
				eth: response.data.results.ethusdt.price,
			};

			return { data: exchangeData };
		} else {
			throw new Error(response.data.RETCODE);
		}
	} catch (error) {
		throw new Error(error);
	}
}

/**
 * huobi global 에서 가져온 전일 종가 기준 usdt 환율을 가져옴
 * @param {string} address
 * @async
 * @function _whitelist_user_check
 * @returns {object} whiteListData
 */
export async function _whitelist_user_check(address) {
	const body = {
		walletAddress: address.toLowerCase(),
	};
	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/whitelist_user_check`,
			data: body,
		});

		if (response.data.RETCODE === 'GET_BOX_BUY_WHITELIST_SUCCESS') {
			let whitelistIndex = [];
			whitelistIndex = response.data.results.map(item => {
				return item.index;
			});
			let whiteListData = {
				index: whitelistIndex,
				count: response.data.count,
				sales: response.data.numberOfSales,
				type: response.data.results[0]?.type,
				eth_price: response.data.results[0]?.kct_nft_index.eth_price,
				total_box: response.data.numberOfSalesTotalBoxBuyCheck,
			};
			return { data: whiteListData };
		}
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * 유저가 whitelist 인지 체크
 * @param {number} index
 * @param {string} address
 * @async
 * @function _postIndex
 * @returns {object} response.data
 */
export async function _postIndex(index, address) {
	const body = {
		boxBuyWhitelistIndex: index,
	};
	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/whitelist_state_update`,
			data: body,
		});
		_inputActionLog(
			address,
			'minting _postIndex',
			JSON.stringify(response)
		);
		if (response.data.RETCODE === 'WHITELIST_STATE_UPDATE_SUCCESS') {
			return response.data;
		}
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * Staking을 진행한 유저의 membership에 따른 베네핏 정보를 리턴
 * @param {string} address
 * @async
 * @function _getMembershipBenefit
 * @returns {string} benefit level
 */
export async function _getMembershipBenefit(address) {
	const body = {
		walletAddress: address,
	};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/check_userstaking`,
			data: body,
		});

		if (response.data.RETCODE === 'USER_STAKING_LIST_CHECK_COMPLETED') {
			if (response.data.results.processing.length > 0) {
				return response.data.results.processing[0];
			} else {
				return 'N/A';
			}
		} else {
			throw new Error(response.data.RETCODE);
		}
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * minting 이벤트에서 박스 구매가 가능한 시간인지 체크
 * @async
 * @function _duman_getTime
 * @returns {string} mintingTime
 */
export async function _duman_getTime() {
	try {
		const response = await axios({
			method: 'get',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/box_duman_public_minting_time_check`,
		});
		return response.data;
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * number확인
 * @param {number} number
 * @function _numbering
 * @returns {number} number
 */
export function _numbering(number) {
	if (number < 10) return `0${number}`;
	else return number;
}
/**
 * 가격을 소수점 3자리 까지 출력
 * @param {number} price
 * @function _fixedPrice
 * @returns {number} price.toFixed(3)
 */
export function _fixedPrice(price) {
	return Number(price.toFixed(3));
}
/**
 * 가격을 소수점 3자리 까지 출력
 * @param {number} price
 * @function _formatPrice
 * @returns {string} price
 */
export function _formatPrice(price) {
	if (!price) return;
	return price?.toLocaleString();
}
/**
 * 가격을 소수점 3자리 까지 출력
 * @param {number} stringPrice
 * @function _unformatPrice
 * @returns {number} price
 */
export function _unformatPrice(stringPrice) {
	return Number(stringPrice.replace(/,/g, ''));
}
/**
 * 접속한 유저의 아이피를 출력
 * @function _trackUserIP
 * @returns {string} ip
 */
export async function _trackUserIP() {
	try {
		const response = await axios.get('https://api.ipify.org?format=json');
		return response.data.ip;
	} catch (error) {
		console.error(error);
	}
}

/**
 * 접속한 유저의 행동을 감시하여 백엔드 서버에 저장
 * @param {string} wallet_address
 * @param {string} action
 * @param {string} function_return
 * @function _inputActionLog
 */
export async function _inputActionLog(wallet_address, action, function_return) {
	try {
		const ip_address = await _trackUserIP();
		const { name, version, os, type } = detect();

		const body = {
			ip_address,
			os,
			browser_name: name,
			browser_type: type,
			wallet_address,
			function_return,
			action,
		};

		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/logging`,
			data: body,
		});

		if (response.data.RETCODE !== 'USER_ACTION_HISTORY_ADD_COMPLETE') {
			throw new Error(response.data.RETCODE);
		}
	} catch (error) {
		console.error(error);
	}
}
/**
 * 로그인을 시도한 유저의 정보를 백엔드 서버에 추가
 * @param {string} email
 * @param {string} email_provider
 * @param {string} wallet_address
 * @function post_Email_Login
 */
export async function post_Email_Login(email, email_provider, wallet_address) {
	const body = {
		email,
		email_provider,
		wallet_address,
	};

	let result = {};

	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/email_login`,
			data: body,
		});
		if (response.data.RETCODE === 'EMAIL_LOGIN_NEW_USER_SUCCESS') {
			result = {
				index: response.data.results,
				email: email,
				email_provider: email_provider,
			};
		} else if (response.data.RETCODE === 'EMAIL_LOGIN_OLD_USER_SUCCESS') {
			result = response.data.results[0];
		}

		return result;
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * 로그인 이후 지갑 서명을 마친 유저의 정보를 백엔드 서버에 추가 (연동)
 * @param {number} user_list_index
 * @param {string} email
 * @param {string} email_provider
 * @param {string} wallet_address
 * @param {string} wallet_provider
 * @function post_Wallet_Linking
 * @return {string} linking state
 */
export async function post_Wallet_Linking(
	user_list_index,
	email,
	email_provider,
	wallet_address,
	wallet_provider
) {
	const body = {
		user_list_index,
		email,
		email_provider,
		wallet_address,
		wallet_provider,
	};
	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/wallet_linking`,
			data: body,
		});
		if (response.data.RETCODE === 'WALLET_LINK_SUCCESS') {
			return 'success';
		} else if (response.data.RETCODE === 'WALLET_ADDRESS_ALREADY_LINKED') {
			return 'fail';
		} else {
			return `that's me`;
		}
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * 유저리스트에 연동되어있는 유저를 연동해제
 * @param {number} user_list_index
 * @function post_Wallet_unlinking
 */
export async function post_Wallet_unlinking(user_list_index) {
	const body = {
		user_list_index,
	};
	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/wallet_unlinking`,
			data: body,
		});
		if (response.data.RETCODE === 'WALLET_UNLINK_SUCCESS') {
		} else {
		}
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * Json data를 암호화
 * @param {json} data
 * @function encryptedData
 */
export const encryptedData = data => {
	const privateKey = process.env.REACT_APP_CRYPTO_PRIVATEKEY;
	const encrypted = AES.encrypt(JSON.stringify(data), privateKey).toString();
	return encrypted;
};
/**
 * Json data를 복호화
 * @param {json} data
 * @function decryptedData
 */
export const decryptedData = data => {
	const privateKey = process.env.REACT_APP_CRYPTO_PRIVATEKEY;
	const makeByteEncryted = AES.decrypt(data, privateKey);
	const decrypted = makeByteEncryted.toString(enc.Utf8);
	return JSON.parse(decrypted);
};
/**
 * moralis db에 올라간 정보를 롧백
 * @param {number} nft_no
 * @param {string} address
 * @function moralis_db_update_rollback
 */
export async function moralis_db_update_rollback(nft_no, address) {
	const body = {
		nft_no,
		address,
	};
	try {
		const response = await axios({
			method: 'post',
			url: `${process.env.REACT_APP_BACKEND_API}/kct/moralis_db_update_rollback`,
			data: body,
		});
		if (response.data.RETCODE === 'MORALIS_DB_UPDATE_ROLLBACK_SUCCESS') {
			return 'success';
		} else if (response.data.RETCODE === 'MORALIS_DB_UPDATE_FAIL') {
			return 'fail';
		}
	} catch (error) {
		throw new Error(error);
	}
}
/**
 * element의 위치를 트래킹
 * @param {element} entries
 * @function checkWhiteArea
 */
export const checkWhiteArea = new IntersectionObserver((entries, observer) => {
	entries.forEach(entry => {
		if (entry.intersectionRatio > 0) {
			entry.target.classList.add('active');
		} else {
			entry.target.classList.remove('active');
		}
	});
});
